import React from 'react';
import PropTypes from 'prop-types';
import uniq from 'lodash/uniq';

import { trans } from '@spotahome/soyuz/client';

import CheckBox from '@spotahome/marketplace-common/src/LEGACY/javascripts/ui/form/form-checkbox';

import BILLS from '../../Filters/bills-config';

import './FiltersExposedSection.scss';
import FiltersExposedWrapper from './FiltersExposedSectionWrapper';

const BillsFilter = ({ features, onFiltersUpdate }) => {
  const isBillSelected = billName => features.includes(billName);

  const handleToggleFilterFeaturesCheckbox = value => isChecked => {
    let options = features;
    if (isChecked) {
      options = [...options, value];
    } else {
      options = options.filter(option => option !== value);
    }

    onFiltersUpdate({
      'features[]': uniq(options)
    });
  };

  return (
    <div className="filters-exposed-section__space">
      <FiltersExposedWrapper title={trans('search.filter.bills')}>
        {BILLS.map(({ name, labelKey, tracking, cy }) => (
          <div className="filters-exposed-section__filter" key={name}>
            <CheckBox
              id={name}
              label={trans(labelKey)}
              onChange={handleToggleFilterFeaturesCheckbox(name)}
              checked={isBillSelected(name)}
              tracking={tracking}
              cy={cy}
            />
          </div>
        ))}
      </FiltersExposedWrapper>
    </div>
  );
};

BillsFilter.propTypes = {
  onFiltersUpdate: PropTypes.func.isRequired,
  features: PropTypes.arrayOf(PropTypes.string).isRequired
};

export default BillsFilter;
